import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/service-card.css";

function ServiceCard({ icon, title, description, link }) {
    return (
        <article className="service-card">
            <div className="service-card__icon">{icon}</div>
            <h3>{title}</h3>
            <p>{description}</p>
            <Link to={link} className="service-card__link">
                Learn More
            </Link>
        </article>
    );
}

export default ServiceCard;